global.jQuery = global.$ = window.jQuery = require('jquery');

/*require('jquery.easing');
require('jquery.color');
require('jquery.inview');
require('jquery.matchHeight');
*/
//require('skrollr.min');
require('jquery.inview');
require('jquery.slick');
//require('swiper');

/*--------------------------------------------------------------------------*
 * ポップアップウィンドウ
 *
 * jquery.openwin.js
 * http://shanabrian.com/web/jquery/window01.php
 *
 * 下記の様にhtml側のrel要素で個別にオプション指定も可。
 * <a href='' class='openwin' rel='scrollbars=yes,target=_self,blur=true'>hoge</a>
 *--------------------------------------------------------------------------*/

$(function () {
	$.fn.openwin = function (settings) {
		settings = $.extend({
			option: {
				width: false,
				height: false,
				top: false,
				left: false,
				menubar: 'no',
				toolbar: 'no',
				location: 'no',
				status: 'no',
				resizable: 'no',
				scrollbars: 'no',
				directories: 'no',
				titlebar: 'yes',
				fullscreen: 'no'
			},
			target: '_blank',
			blur: false,
			focus: false
		}, settings);

		$(this).on('click', function () {
			var options = [];
			var target = settings.target;
			var url = $(this).attr('href');

			if ($(this).attr('rel')) {
				var rel = $(this).attr('rel').split(',');
				var relOption = {};
				$.each(settings.option, function (i, rel) {
					var a = rel[i].split('=');
					relOption[a[0]] = a[1];
				});
			}

			$.each(settings.option, function (k) {
				var v = settings.option[k];
				if (relOption) {
					if (relOption[k]) {
						v = relOption[k];
					}
				}
				if (v) {
					options.push(k + '=' + v);
				}
			});
			if (relOption) {
				if (relOption['target']) {
					target = relOption['target'];
				}
			}
			var newWin = window.open(url, target, options.join(','));
			if (settings.blur === true) {
				newWin.blur();
			}
			if (settings.focus === true) {
				newWin.focus();
			}
			return false;
		});
		return this;
	};
});


$(function () {
	// ポップアップウィンドウの設定
	$('a.openwin').openwin({
		option: {
			width: 1000,
			height: 900,
			top: false,
			left: false,
			menubar: 'no',
			toolbar: 'no',
			location: 'no',
			status: 'no',
			resizable: 'yes',
			scrollbars: 'yes',
			directories: 'no',
			titlebar: 'yes',
			fullscreen: 'no'
		}
	});
});




$(function () {

	/*--------------------------------------------------------------------------*
	 * menu
	 *--------------------------------------------------------------------------*/

	var flag = false;
	var $navGlobal = $('.nav-global');
	var headerHeight = $('.header').innerHeight();
	var headerInnerHeight = $('.header__inner').innerHeight();
	var $humberger = $('.header-humberger');
	var windowWidth = $(window).width();
	var navFlag = false;

	$(window).on('load resize', function () {
		if (windowWidth > 768) {
			var headerHeight = $('.header').innerHeight();

		} else {
			var headerHeight = $('.header').innerHeight();
		}
	});

	$humberger.on('click', function () {
		if (!flag) {
			$humberger.addClass('active');
			$navGlobal.css('top', headerInnerHeight + 3 + 'px');
			$navGlobal.fadeIn(function () {
				flag = true;
			});
		} else {
			$humberger.removeClass('active');
			$navGlobal.fadeOut(function () {
				flag = false;
			});
		}
	});



	

	// $navMidDrop.hover(function () {
	// 	$(this).children('.index-section01__element__dropdown__inner').show();
	// }, function () {
	// 	$(this).children('.index-section01__element__dropdown__inner').hide();
	// })

	// $navDropBox.on('click', function () {
	// 	if (!navFlag) {
	// 		$(this).children('.dropdown__inner').show();

	// 	} else {
	// 		$(this).children('.dropdown__inner').hide();
			
	// 	}
	// });

/*	$navDropBoxPC.hover(function () {
		$(this).children('.dropdown__inner').show();
	}, function () {
		$(this).children('.dropdown__inner').hide();
	})
	$navDropBoxSP.on('click',function(){
		$(this).children('.dropdown__inner').slideToggle(2);
	});


	$navMidDropPC.hover(function () {
		$(this).children('.index-section01__element__dropdown__wrapper').show();
	}, function () {
		$(this).children('.index-section01__element__dropdown__wrapper').hide();
	});
	$navMidDropSP.on('click',function(){
		$(this).children('.index-section01__element__dropdown__wrapper').slideToggle(2);
	});*/
	
	
	/*
	$('.link_area').on('click',function(){
		location.href = $(this).attr('data-url');
	});
	*/
	
	
//header footer fixing
/*  var fixingArea = siteFooter.find(".fixingArea");

  $(window).on("load resize scroll", function(){
    if(menuBtn.is(":visible")) return;
    var wH = $(window).height();
    var headerH = siteHeader.height();
    var infoBase = siteFooter.find(".infoes-base");
    var baseCoord = infoBase.offset().top;
    var baseH = infoBase.height();
    var scrT = $(window).scrollTop();
    var wB = scrT + wH;

    if(scrT >= headerH){
      infoBase.fadeIn();
		$('.footer__pagetop').fadeIn();
    }else{
      infoBase.stop(true, true).fadeOut();
		$('.footer__pagetop').fadeOut();
    }

    if(wB <= baseCoord + baseH){
      if($("#top").length && scrT < wH){
        infoBase.find(".base").css({
          position: "absolute"
        });
        $(".pageTop").addClass("hide");
      }else{
        infoBase.find(".base").css({
          position: "fixed"
        });
        $(".pageTop").removeClass("hide");
      }
    }else{
      infoBase.find(".base").css({
        position: "absolute"
      });
    }
  });*/
	
	/*--------------------------------------------------------------------------*
	 * スムーズスクロール
	 *--------------------------------------------------------------------------*/
	$('a[href^="#"').click(function () {
		var speed = 500;
		var href = $(this).attr('href');
		var target = $(href == '#' || href == '' ? 'html' : href);
		var position = target.offset().top;
		$('html, body').animate({
			scrollTop: position
		}, speed, 'swing');
		return false;
	});


	/*--------------------------------------------------------------------------*
	 * inview 設定
	 *--------------------------------------------------------------------------*/

	//COMMON

	$('.inviewset').css('opacity', '0');

	$('.inviewset').on('inview', function () {
		$(this).delay(200).animate({
			opacity: '1'
		}, 1000);
	});

	$('.inviewchain01').css('opacity', '0');
	$('.inviewchain02').css('opacity', '0');
	$('.inviewchain03').css('opacity', '0');
	$('.inviewchain04').css('opacity', '0');
	$('.inviewchain05').css('opacity', '0');
	$('.inviewchain06').css('opacity', '0');

	$('.inviewchainwrap').on('inview', function () {
		$(this).find('.inviewchain01').delay(300).animate({
			opacity: '1'
		}, 600);
		$(this).find('.inviewchain02').delay(600).animate({
			opacity: '1'
		}, 600);
		$(this).find('.inviewchain03').delay(900).animate({
			opacity: '1'
		}, 600);
		$(this).find('.inviewchain04').delay(1200).animate({
			opacity: '1'
		}, 600);
		$(this).find('.inviewchain05').delay(1500).animate({
			opacity: '1'
		}, 600);
		$(this).find('.inviewchain06').delay(1800).animate({
			opacity: '1'
		}, 600);
	});

/*var siteHeader = $('header');
var siteFooter $('footer');
var menuBtn = siteHeader.find('.header-humberger');
var fixingArea = siteFooter.find('.fixingArea');

  $(window).on('load resize scroll', function(){
    if(menuBtn.is(':visible')) return;
    var wH = $(window).height();
    var headerH = siteHeader.height();
    var infoBase = siteFooter.find('.footer__base');
    var baseCoord = infoBase.offset().top;
    var baseH = infoBase.height();
    var scrT = $(window).scrollTop();
    var wB = scrT + wH;

    if(scrT >= headerH){
    }else{
    }

    if(wB <= baseCoord + baseH){
      if($('body').length && scrT < wH){
        infoBase.find('.footer__inner').css({
          position: 'absolute'
        });
        $('.footer__pagetop').addClass('hide');
      }else{
        infoBase.find('.footer__inner').css({
          position: 'fixed'
        });
        $('.footer__pagetop').removeClass('hide');
      }
    }else{
      infoBase.find('footer__inner').css({
        position: 'absolute'
      });
    }
  });*/

    
	/*--------------------------------------------------------------------------*
	 * MV
	 *--------------------------------------------------------------------------*/
/*    $('.index-hero__element').on('click', function () {
        $('.index-hero__element').removeClass('thumb_on');
        $(this).addClass('thumb_on');
        
        if($(this).hasClass('index-hero__element-01')){
            $('.mv_img01').addClass('mv_on');
            $('.mv_img02').removeClass('mv_on');
            $('.mv_img03').removeClass('mv_on');
        } else if($(this).hasClass('index-hero__element-02')) {
            $('.mv_img02').addClass('mv_on');
            $('.mv_img01').removeClass('mv_on');
            $('.mv_img03').removeClass('mv_on');
        } else {
            $('.mv_img01').removeClass('mv_on');
            $('.mv_img02').removeClass('mv_on');
            $('.mv_img03').addClass('mv_on');
        }
    });*/
    
    

	/*--------------------------------------------------------------------------*
	 * Slider
	 *--------------------------------------------------------------------------*/
    
 /*     var swiper = new Swiper('.swiper-container', {
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-my-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                  return '<span class="' + className + '">' + '<img src="img/modelroom/mr' + (index + 1) + '.jpg" alt="">' + '</span>';
                },
            },
            loop: true,
            speed: 1000,
            autoplay: {
              delay: 4000,
              disableOnInteraction: true,
            },
      });
    */
    
    
    // TOP MV
/*    var topMainSlider = ".index-hero__slide";
    var topThumb_slider = ".index-hero__thumb"; 
    
    $(topMainSlider).slick({
        autoplay: true,
        autoplaySpeed: 3500,
        speed: 1000,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          fade: true,
          asNavFor: topThumb_slider,
          prevArrow: '<span class="slide-arrow prev-arrow">〈</span>',
          nextArrow: '<span class="slide-arrow next-arrow">〉</span>'
    });
    $(topThumb_slider).slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: true,
          centerMode: true,
          focusOnSelect: true,
          asNavFor: topMainSlider
    });*/
 

});


    
/*--------------------------------------------------------------------------*
 * スクローラー設定
 *--------------------------------------------------------------------------*/
/*var isMobile = false;
isMobile = $('html').is('.skrollr-mb');
if (!isMobile) {
	window.onload = function () {
		var s = skrollr.init({
			forceHeight: false,
			mobileDeceleration: 0.01,
			mobileCheck: function () {
				return isMobile;
			}
		});
	}
}*/



/*--------------------------------------------------------------------------*
 * PANORAMA
 *--------------------------------------------------------------------------*/
/*$(window).on('load resize',function(){
  $('.panorama-view').scrollLeft(150);
  var w=$('.panorama-view').prop('scrollWidth')-$('.panorama-view').prop('clientWidth');
  var timerID;
  var offset=2;

  var ua = navigator.userAgent;
  if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
	var ms = 20;
  } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
	var ms = 15;
  } else {
	var ms = 10;
  }

  var touched = false;
  $('.leftArrow,.rightArrow').bind({
	'touchstart mousedown': function (e) {
	  touched = true;
	  e.preventDefault();
	  var myClass = $(this).attr('class');
	  var myId = '#' + $(this).parent('.panorama-view').attr('id');
	  timerID = setInterval(function () {
		var pos = $(myId).scrollLeft() + (myClass == 'leftArrow' ? -1 : 1) * offset;

		if (pos <= 0) {
		  $(myId).children('.rightArrow').removeClass('arwNone');
		  $(myId).children('.leftArrow').addClass('arwNone').dequeue();
		} else if (pos >= (w)) {
		  $(myId).children('.rightArrow').addClass('arwNone').dequeue();
		  $(myId).children('.leftArrow').removeClass('arwNone');
		} else {
		  $(myId).children('.leftArrow').removeClass('arwNone');
		  $(myId).children('.rightArrow').removeClass('arwNone');
		}
		$(myId).scrollLeft(pos);
		// console.log(myId);
		// console.log(w);
		// console.log(pos);
	  }, ms);
	},
	'touchend mouseup mouseout': function (e) {
	  if (touched) {
		clearInterval(timerID);
	  }
	  touched = false;
	  e.preventDefault();
	}
  });
});*/

/*--------------------------------------------------------------------------*
 * fix_nav/ fix-contact / pagetop
 *--------------------------------------------------------------------------*/
/*var flug = true;
$(window).on('scroll',function(){
	
	var ts = $('.nav-global').offset().top;
	var wH = $(window).height();
	var scrT = $(this).scrollTop();
	var wB = scrT + wH;
	var contactT = $('.footer__contact').offset().top;
	var contactH = $('.footer__contact').height();
	var cTcH = contactT + contactH;
	
	 if(flug){
		flug = false;
		setTimeout(function(){

			if(scrT >= 112){ // g_nav fix pc
			  $('.nav-global').addClass('fixed');
			} else if (sctT < 112) {
			  $('.nav-global').removeClass('fixed');
			}

			// g_nav fix sp
			var bs = $('.header__icon').offset().top;
			if(scrT > bs){
			  $('.header__icon').addClass('fixed');
			} else {
			  $('.header__icon').removeClass('fixed');
			}


			if(wB < cTcH) {	// contact
				$('.footer__contact').addClass('fixed');
			} else {
				$('.footer__contact').removeClass('fixed');
			}


			if(scrT > 200) {	// pagetop, contact
				$('.footer__pagetop').addClass('visible_btn');
				$('.footer__contact').removeClass('invisible');
			} else {
				$('.footer__pagetop').removeClass('visible_btn');
				$('.footer__contact').addClass('invisible');
			}
		
		 flug = true;
      return flug;
    }, 100);
  }
});*/
